export default __webpack_public_path__ + "afdb2f71f6252dc547f59dc4647cdba4.mp3";